import { Route } from 'react-router-dom';
import { ESharedRoutes, ERouteContext } from '../types';
import { getSharedSettingsRoutes } from './settingsRoutesUtil';

import { PlayersView } from 'views/Players/PlayersView';
import { BlockedPlayersTable } from 'components/Players/BlockedPlayersTable/BlockedPlayersTable';
import LocalizationView from 'views/Localization/LocalizationView';
import ProfileView from 'views/Profile/ProfileView';
import PersonalInfo from 'components/PersonalInfo/PersonalInfo';
import PasswordTab from 'components/PasswordsTab/PasswordTab';
import { ThemeView } from 'components/Theme/Theme';
import { GeneralSettings } from 'components/Theme/GeneralSettings/GeneralSettings';
import { StoreTheme } from 'components/Theme/StoreTheme/StoreTheme';
import { LoginTheme } from 'components/Theme/LoginTheme/LoginTheme';
import { AccountApprovalModalTheme } from 'components/Theme/AccountApprovalModalTheme';
import { CompletedTheme } from 'components/Theme/CompletedTheme/CompletedTheme';
import CheckoutTheme from 'components/Theme/CheckoutTheme/CheckoutTheme';
import ProductsView from 'views/Products/ProductsView';
import OffersUIView from 'views/OffersUI/OffersUIView';
import BadgesView from 'views/Badges/BadgesView';
import AssetsView from 'views/Assets/AssetsView';
import OffersView from 'views/Bundles/OffersView';
import PromotionsView from 'views/Promotions/PromotionsView';
import PopupsView from 'views/Popups/PopupsView';
import RollingOffersView from 'views/RollingOffers/RollingOffersView';
import CheckoutLinksView from 'views/CheckoutLinks/CheckoutLinksView';
import { PricingView } from 'views/Pricing/PricingView';
import PricingTable from 'components/Pricing/PricingTable';
import PricingSettings from 'components/Pricing/PricingSettings';
import PricingForm from 'components/Pricing/PricingForm';

export const getSharedRoutes = (name: ESharedRoutes, context = ERouteContext.PROJECT): JSX.Element => {
  const sharedRoutesMap = {
    [ESharedRoutes.PLAYERS]: (
      <Route path="players/*" element={<PlayersView />}>
        <Route path="blocked" element={<BlockedPlayersTable />} />
      </Route>
    ),
    [ESharedRoutes.LOCALIZATION]: (
      <Route path="localization/*" element={<LocalizationView />} />
    ),
    [ESharedRoutes.SETTINGS]: getSharedSettingsRoutes(context),
    [ESharedRoutes.PROFILE]: (
      <Route path="profile" element={<ProfileView />}>
        <Route path="personal" element={<PersonalInfo />} />
        <Route path="password" element={<PasswordTab />} />
      </Route>
    ),
    [ESharedRoutes.THEME]: (
      <Route path="theme" element={<ThemeView context={context}/>}>
        <Route path="general" element={<GeneralSettings />} />
        <Route path="store" element={<StoreTheme />} />
        <Route path="login" element={<LoginTheme />} />
        <Route
          path="account-approval-modal"
          element={<AccountApprovalModalTheme />}
        />
        <Route path="completed" element={<CompletedTheme />} />
        <Route path="checkout" element={<CheckoutTheme />} />
      </Route>
    ),
    [ESharedRoutes.PRODUCTS]: (
      <Route path="products/*" element={<ProductsView />} />
    ),
    [ESharedRoutes.OFFERS_UI]: (
      <Route path="offersui/*" element={<OffersUIView />} />
    ),
    [ESharedRoutes.BADGES]: (
      <Route path="badges/*" element={<BadgesView />} />
    ),
    [ESharedRoutes.ASSETS]: (
      <Route path="assets" element={<AssetsView />} />
    ),
    [ESharedRoutes.BUNDLES]: (
      <Route path="bundles/*" element={<OffersView />} />
    ),
    [ESharedRoutes.PROMOTIONS]: (
      <Route path="promotions/*" element={<PromotionsView />} />
    ),
    [ESharedRoutes.POPUPS]: (
      <Route path="popups/*" element={<PopupsView />} />
    ),
    [ESharedRoutes.ROLLING]: (
      <Route path="rolling/*" element={<RollingOffersView />} />
    ),
    [ESharedRoutes.CHECKOUT_LINKS]: (
      <Route path="checkoutlinks/*" element={<CheckoutLinksView />} />
    ),
    [ESharedRoutes.PRICING]: (
      <>
        <Route path="pricing" element={<PricingView context={context} />}>
          <Route path="points" element={<PricingTable />} />
          <Route path="settings" element={<PricingSettings />} />
        </Route>
        <Route path="pricing/form" element={<PricingForm />} />
        <Route path="pricing/points/form/:pricePointId" element={<PricingForm />} />
      </>
    )
  };

  return sharedRoutesMap[name];
}; 